<template>
  <v-card
    style="border-radius: 10px;overflow: hidden"
    :key="'generic_' + generic.id"
    class="card ml-1 mr-1 generic-card"
    :style="{ width: size == 'big' ? '300px' : '200px' }"
  >
    <div
      class="card-img"
      :style="{ height: size == 'big' ? '300px' : '200px' }"
      style="border-bottom: 1px solid #eee"
    >
      <template v-if="generic.productid && currentProduct.photourl">
        <div v-if="loadingProduct" class="text-xs-center">
          <pulse-loader :color="$vuetify.theme.primary" :size="'15px'"></pulse-loader>
        </div>
        <div
          v-else
          :style="{
            height: size == 'big' ? '300px' : '200px',
            'background-image': 'url(\'' + currentProduct.photourl + '\')'
          }"
          style="width: 100%; height: 200px;background-size: cover;background-position: center;background-repeat: no-repeat;"
        ></div>
      </template>
      <template v-else-if="generic.image_url">
        <div
          :style="{
            height: size == 'big' ? '300px' : '200px',
            'background-image': 'url(\'' + generic.image_url + '\')'
          }"
          style="width: 100%; height: 200px;background-size: cover;background-position: center;background-repeat: no-repeat;"
        ></div>
        <!-- <img class="card-img-top" :src="generic.image_url"  > -->
      </template>

      <template v-else>
        <div
          :style="{
            height: size == 'big' ? '300px' : '200px',
            'background-image': 'url(\'/static/img/assets/generic/generic_default_thumbnail.png\')'
          }"
          style="width: 100%; height: 200px;background-size: cover;background-position: center;background-repeat: no-repeat;"
        ></div>
      </template>
    </div>

    <div
      class="card-body"
      style="padding: 0px 8px;overflow: hidden"
      :style="{ height: size == 'small' ? '120px' : '120px' }"
    >
      <h4
        style="font-weight: 600;margin: 10px 0px;"
        :style="{ 'font-size': size == 'big' ? 'inherit' : '12px' }"
      >
        <template v-if="generic.productid">
          <div v-if="loadingProduct" class="text-xs-center">
            <pulse-loader :color="$vuetify.theme.primary" :size="'15px'"></pulse-loader>
          </div>
          <template v-else>
            <specialtext :text="currentProduct.name" :truncate="40"></specialtext>
          </template>
        </template>
        <template v-else-if="generic.title">
          <specialtext :text="generic.title" :truncate="40"></specialtext>
        </template>
        <template v-else
          >No Text</template
        >
      </h4>

      <p :style="{ 'font-size': size == 'big' ? 'inherit' : '12px' }">
        <template v-if="generic.productid">
          <div v-if="loadingProduct" class="text-xs-center">
            <pulse-loader :color="$vuetify.theme.primary" :size="'15px'"></pulse-loader>
          </div>
          <template v-else>
            <specialtext :text="currentProduct.description" :truncate="90"></specialtext>
          </template>
        </template>
        <template v-else-if="generic.subtitle">
          <specialtext :text="generic.subtitle" :truncate="90"></specialtext>
        </template>
        <template v-else
          >No Text</template
        >
      </p>
    </div>

    <div class="card-footer">
      <ul class="list-group list-group-flush" style="margin-bottom: 0px;">
        <template v-if="generic.buttons.length > 0">
          <li
            class="list-group-item"
            style="border:none; border-top:1px solid #eee;border-radius: 0px;text-align: center;"
            :style="{ padding: size == 'small' ? '5px 0' : '15px 0' }"
            v-for="(button, bindex) in generic.buttons"
            :key="bindex"
          >
            <span>
              <template v-if="button.type == 'web_url'">
                <a :href="button.url" target="_BLANK">
                  {{ button.title }}
                </a>
              </template>
              <template v-else>
                {{ button.title }}
              </template>
            </span>
          </li>
        </template>
        <template v-else>
          <li
            class="list-group-item"
            style="border:none; border-top:1px solid #eee;border-radius: 0px;text-align: center;"
            :style="{ padding: size == 'small' ? '5px 0' : '15px 0' }"
          >
            <span>-</span>
          </li>
        </template>
      </ul>
    </div>
  </v-card>
</template>

<script>
import specialtext from '@/components/elements/specialtext'
import { mapGetters } from 'vuex'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
export default {
  props: {
    generic: [Object, String, Array],
    size: {
      type: String,
      default: 'big'
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      products: 'getProducts',
      loadingProduct: 'getLoadingProduct'
    }),
    currentProduct: function() {
      var vm = this
      if (vm.selectedBot.theme == 'ecommercebasic') {
        if (vm.generic.productid) {
          return vm.products.find(function(val) {
            return val.id == vm.generic.productid
          })
        }
      }
      return false
    }
  },
  components: {
    specialtext,
    PulseLoader
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/GenericViewerItem.vue